import React, { FC } from 'react'
import { Plural } from '@lingui/macro'

import { linkBuilder } from 'shared/linkBuilder'
import GroupAvatar from '../../../components/common/group/group-avatar/GroupAvatar'
import { GroupListQuery } from '../ManageGroupsPage.codegen'
import { TypeOfElement } from 'types/generic'
import { useCPDFeatureFlag } from 'front-end/src/app/hooks/useFeatureFlags'
import { brandColors } from 'shared/basicPalette'
import IconBookOpen from '../../../components/common/icon/IconBookOpen'
import { Tooltip, Box, Flex, LinkOverlay } from 'front-end/src/components'

import './Item.less'

interface IProps {
  group: TypeOfElement<
    NonNullable<NonNullable<GroupListQuery['admin']>['organisation']>['groups']
  >
}

const Item: FC<IProps> = (props: IProps) => {
  const { isCPDEnabledInAccountSettings, cpdAlias } = useCPDFeatureFlag()
  const {
    group: { id, name, usersCount, is_cpd }
  } = props

  return (
    <LinkOverlay to={linkBuilder.groupDetail(id)} className="Groups__item">
      <GroupAvatar group={{ name }} />
      <h3>
        {name}
        {isCPDEnabledInAccountSettings && is_cpd && (
          <Flex alignItems="center" ml="8px">
            <Tooltip text={cpdAlias}>
              <IconBookOpen color={brandColors.grey.mid} fontSize="14px" />
            </Tooltip>
          </Flex>
        )}
      </h3>

      <Box color={brandColors.grey[500]} marginLeft={'1rem'}>
        <Plural
          value={usersCount}
          _0="Empty"
          one="# Member"
          other="# Members"
        />
      </Box>
    </LinkOverlay>
  )
}

export default Item
